var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderWithBgFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 152,
    viewBox: "0 0 300 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277",
    transform: "translate(-38 -220)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 300,
    height: 152,
    transform: "translate(38 220)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(145 261)",
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M2298.487,750.563v38.212q-8.3-8.269-16.6-16.539c-1.659-1.652-2.884-1.648-4.541,0q-9.463,9.444-18.913,18.9c-.469.47-.71.47-1.174,0-2.672-2.713-5.378-5.392-8.074-8.08-1.6-1.592-2.873-1.584-4.486.026l-28.628,28.572c-1.085,1.083-1.074,1.073-2.162-.051a9.436,9.436,0,0,1-2.154-4.233v-56.81c.034-.044.086-.083.1-.132,1.239-4.537,3.977-6.618,8.712-6.619h27.866q20.879,0,41.757,0a8.091,8.091,0,0,1,6.9,3.445A11.349,11.349,0,0,1,2298.487,750.563Zm-54.458,14.816a10.691,10.691,0,0,0-21.382.013,10.691,10.691,0,0,0,21.382-.013Z",
    transform: "translate(-2211.75 -743.812)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M2329.964,910.791v11.5a.8.8,0,0,0-.131.21,7.972,7.972,0,0,1-8.339,6.54q-34.08,0-68.16,0c-.292,0-.608.1-.923-.122.119-.141.215-.273.329-.387q12.6-12.579,25.2-25.164c.4-.4.617-.37,1,.015,2.718,2.744,5.459,5.467,8.194,8.194,1.532,1.528,2.84,1.528,4.371,0q9.46-9.44,18.907-18.894c.514-.516.779-.593,1.342-.027q8.734,8.79,17.529,17.521C2329.5,910.388,2329.735,910.585,2329.964,910.791Z",
    transform: "translate(-2243.227 -858.727)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M2287.969,825.6a5.635,5.635,0,1,1,5.677-5.624A5.675,5.675,0,0,1,2287.969,825.6Z",
    transform: "translate(-2266.398 -798.404)",
    fill: "#dbdbdb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderWithBgFilled);
export default __webpack_public_path__ + "static/media/Placeholder_with_BG_filled.5a86ba01cae1e2fbcae6b422c109ec61.svg";
export { ForwardRef as ReactComponent };